import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import LoginForm from '../AccountForms/LoginForm';
import RegisterForm from '../AccountForms/RegisterForm';
import RecoveryForm from '../AccountForms/RecoveryForm';
import WishlistForm from '../AccountForms/WishlistForm';

var Account = function Account(_ref) {
  var formType = _ref.formType,
      toggleAccountForm = _ref.toggleAccountForm,
      isModal = _ref.isModal;

  useEffect(function () {
    if (['LOGIN', 'REGISTER'].includes(formType)) {
      // if active and login or register form
      if (!window.socialLogin) {
        // if first render, must load script to init one social login
        var script = document.createElement('script');
        script.src = 'https://sociallogin-3cb0.kxcdn.com/resource/resource.js?shop=dormifyplus.myshopify.com';
        document.body.appendChild(script);
      } else {
        // else run init function to change
        // <div className="one-click-social-login" />
        // to the social login button iframe
        window.socialLogin.init();
      }
    }
  }, [formType]);

  return {
    // switch statement for `formType`
    LOGIN: React.createElement(LoginForm, { toggleAccountForm: toggleAccountForm, isModal: isModal }),
    REGISTER: React.createElement(RegisterForm, { toggleAccountForm: toggleAccountForm, isModal: isModal }),
    RECOVER: React.createElement(RecoveryForm, { toggleAccountForm: toggleAccountForm, isModal: isModal }),
    WISHLIST: React.createElement(WishlistForm, { toggleAccountForm: toggleAccountForm, isModal: isModal }),
    '': React.createElement(LoginForm, { toggleAccountForm: toggleAccountForm, isModal: isModal })
  }[formType];
};

Account.propTypes = {
  formType: PropTypes.oneOf(['', 'LOGIN', 'REGISTER', 'RECOVER', 'WISHLIST']),
  toggleAccountForm: PropTypes.func.isRequired,
  isModal: PropTypes.bool
};

Account.defaultProps = {
  formType: 'LOGIN',
  isModal: false
};
export default Account;